import { render, staticRenderFns } from "./OrderDayRow.vue?vue&type=template&id=27136186&scoped=true"
import script from "./OrderDayRow.vue?vue&type=script&lang=js"
export * from "./OrderDayRow.vue?vue&type=script&lang=js"
import style0 from "./OrderDayRow.vue?vue&type=style&index=0&id=27136186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27136186",
  null
  
)

export default component.exports